import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbDialogService } from '@nebular/theme';
import { Actions, Store, ofActionSuccessful } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Content } from 'src/app/models/content';
import { ContentState, LoadContentSuccess } from '../../../redux';
import { ViewContentComponent } from '../view-content.component';

@Component({
  selector: 'app-modal-container-content',
  template: ''
})
export class ModalContainerContentComponent implements OnDestroy, OnInit {
  public content$: Observable<Content[] | undefined> = inject(Store).select(ContentState.content);
  private unsubscribe = new Subject<void>();

  public tableData?: Content[];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dialogService: NbDialogService,
    private actions$: Actions
  ) {}

  public ngOnInit() {
    this.content$.pipe(takeUntil(this.unsubscribe)).subscribe((data) => (this.tableData = data));
    this.route.params.pipe(takeUntil(this.unsubscribe)).subscribe((params) => {
      if (this.tableData) {
        const found = this.tableData?.find((element) => String(element.content_id) === params.id);
        if (found) {
          this.dialogService
            .open(ViewContentComponent, {
              closeOnEsc: false,
              closeOnBackdropClick: false,
              context: {
                content: found
              }
            })
            .onClose.subscribe(() => {
              this.router.navigateByUrl('content/table');
            });
        } else {
          this.router.navigateByUrl('content/table');
        }
      } else {
        this.actions$.pipe(ofActionSuccessful(LoadContentSuccess), takeUntil(this.unsubscribe)).subscribe(() => {
          const found = this.tableData?.find((element) => String(element.content_id) === params.id);
          if (found) {
            this.dialogService
              .open(ViewContentComponent, {
                closeOnEsc: false,
                closeOnBackdropClick: false,
                context: {
                  content: found
                }
              })
              .onClose.subscribe(() => {
                this.router.navigateByUrl('content/table');
              });
          } else {
            this.router.navigateByUrl('content/table');
          }
        });
      }
    });
  }

  public ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
